import {
  FETCH_CURRENT_SUBSCRIPTION,
  FETCH_CURRENT_SUBSCRIPTION_SUCCESS,
  FETCH_PLANS,
  FETCH_PLANS_SUCCESS,
  FETCH_INVOICE_INFO,
  FETCH_INVOICE_INFO_SUCCESS,
  CALCULATE_PRICE,
  CALCULATE_PRICE_SUCCESS,
  VALIDATE_COUPON,
  VALIDATE_COUPON_SUCCESS,
  CLEAR_COUPON,
  PURCHASE_SUBSCRIPTION,
  PURCHASE_SUBSCRIPTION_SUCCESS,
  FETCH_SUBSCRIPTION_HISTORY,
  FETCH_SUBSCRIPTION_HISTORY_SUCCESS,
  SCHEDULE_DOWNGRADE,
  SCHEDULE_DOWNGRADE_SUCCESS,
  CANCEL_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION_SUCCESS,
  SET_PAYMENT_REQUIRED,
  CLEAR_PAYMENT_REQUIRED,
  SUBSCRIPTION_API_ERROR,
  SET_SUBSCRIPTION_RESOLVED,
} from "./actionTypes"

const initialState = {
  currentStatus: null,
  // Abonelik durumu en az bir kez sunucudan sorgulandı mı? (gate mount kararı için)
  resolved: false,
  plans: [],
  history: [],
  priceCalculation: null,
  couponValidation: null,
  invoiceInfo: null,
  loading: false,
  purchaseLoading: false,
  downgradeLoading: false,
  cancelLoading: false,
  paymentRequired: null,
  error: null,
}

const subscription = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CURRENT_SUBSCRIPTION:
      return { ...state, loading: true, error: null }
    case FETCH_CURRENT_SUBSCRIPTION_SUCCESS:
      return { ...state, loading: false, currentStatus: action.payload, resolved: true }

    case SET_SUBSCRIPTION_RESOLVED:
      return { ...state, resolved: true }

    case FETCH_PLANS:
      return { ...state, loading: true, error: null }
    case FETCH_PLANS_SUCCESS:
      return { ...state, loading: false, plans: action.payload }

    case FETCH_INVOICE_INFO:
      return { ...state, loading: true, error: null }
    case FETCH_INVOICE_INFO_SUCCESS:
      return { ...state, loading: false, invoiceInfo: action.payload }

    case CALCULATE_PRICE:
      return { ...state, loading: true, error: null }
    case CALCULATE_PRICE_SUCCESS:
      return { ...state, loading: false, priceCalculation: action.payload }

    case VALIDATE_COUPON:
      return { ...state, loading: true, error: null }
    case VALIDATE_COUPON_SUCCESS:
      return { ...state, loading: false, couponValidation: action.payload }
    case CLEAR_COUPON:
      return { ...state, couponValidation: null }

    case PURCHASE_SUBSCRIPTION:
      return { ...state, purchaseLoading: true, error: null }
    case PURCHASE_SUBSCRIPTION_SUCCESS:
      return { ...state, purchaseLoading: false }

    case FETCH_SUBSCRIPTION_HISTORY:
      return { ...state, loading: true, error: null }
    case FETCH_SUBSCRIPTION_HISTORY_SUCCESS:
      return { ...state, loading: false, history: action.payload }

    case SCHEDULE_DOWNGRADE:
      return { ...state, downgradeLoading: true, error: null }
    case SCHEDULE_DOWNGRADE_SUCCESS:
      return { ...state, downgradeLoading: false }

    case CANCEL_SUBSCRIPTION:
      return { ...state, cancelLoading: true, error: null }
    case CANCEL_SUBSCRIPTION_SUCCESS:
      return { ...state, cancelLoading: false }

    case SET_PAYMENT_REQUIRED:
      return { ...state, paymentRequired: action.payload }
    case CLEAR_PAYMENT_REQUIRED:
      return { ...state, paymentRequired: null }

    case SUBSCRIPTION_API_ERROR:
      return { ...state, loading: false, purchaseLoading: false, downgradeLoading: false, cancelLoading: false, error: action.payload }

    default:
      return state
  }
}

export default subscription
